/* Boomn custom — Seek One
   Product card swatches: update price and stock, not just the image.

   The theme's <product-card> element already handles the swatch click but only
   swaps the image and the product href. This listens for the same event during
   the bubbling phase and fills in the rest. Values come pre-formatted from
   snippets/option-value.liquid so currency formatting stays server-side. */

(function () {
  'use strict';

  var SWATCH_SELECTOR = '.product-card__swatch-list input[type="radio"]';

  function setPriceText(element, text) {
    var screenReaderLabel = element.querySelector('.sr-only');

    element.textContent = '';

    if (screenReaderLabel) {
      element.appendChild(screenReaderLabel);
    }

    element.appendChild(document.createTextNode(text));
  }

  function updateCard(card, input) {
    var price = input.getAttribute('data-variant-price');

    if (!price) return;

    var priceList = card.querySelector('.product-card__info price-list');

    if (!priceList) return;

    var salePrice = priceList.querySelector('sale-price');
    var compareAtPrice = priceList.querySelector('compare-at-price');
    var newCompareAt = input.getAttribute('data-variant-compare-at-price');
    var onSale = Boolean(newCompareAt);

    if (salePrice) {
      setPriceText(salePrice, price);
      /* snippets/price-list.liquid uses text-on-sale for a discounted price and
         text-subdued for a regular one. Toggling only the first would leave the
         element with no colour class at all. */
      salePrice.classList.toggle('text-on-sale', onSale);
      salePrice.classList.toggle('text-subdued', !onSale);
    }

    if (onSale) {
      if (compareAtPrice) {
        setPriceText(compareAtPrice, newCompareAt);
      } else if (salePrice) {
        compareAtPrice = document.createElement('compare-at-price');
        compareAtPrice.className = salePrice.className
          .replace('text-on-sale', '')
          .replace('text-subdued', '')
          .trim();
        compareAtPrice.classList.add('text-subdued', 'line-through');
        compareAtPrice.textContent = newCompareAt;
        priceList.appendChild(compareAtPrice);
      }
    } else if (compareAtPrice) {
      compareAtPrice.remove();
    }

    /* The theme's sold-out badge is rendered per product, not per variant, so
       the per-variant notice lives next to the price instead. */
    var available = input.getAttribute('data-variant-available') !== 'false';
    card.classList.toggle('is-variant-unavailable', !available);
  }

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;

      if (!input.matches || !input.matches(SWATCH_SELECTOR)) return;

      var card = input.closest('product-card');

      if (card) updateCard(card, input);
    },
    false
  );
})();
